import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { validateExtraLocation } from './utils';

export default function* listenSetExtraLocation() {
  yield takeEvery(actionTypes.SET_EXTRA_LOCATION, validateExtraLocation);
}
